import { useRef, useEffect, useState, useCallback } from 'react';
import copy from "fast-copy";
import { produce } from "immer";
import { useImmer } from "use-immer";

export const useMounted = () => {
    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    return mounted;
}

export const useMState = (initState) => {
    const [state, setState] = useState(initState);
    const mounted = useMounted();

    const mountedSetState = (callBackState) => {
        if (mounted.current) {
            setState(callBackState);
        } else {
            console.log("Skip setState on unmounted");
        }
    };

    return [state, mountedSetState];
}

export const useIState = (initState) => {
    const [state, setState] = useImmer(initState);
    const mounted = useMounted();

    const updateState = useCallback((callBack) => {
        if (mounted.current) {
            setState(callBack);
        } else {
            console.log("Skip updateState on unmounted");
        }

    }, []);

    return [state, updateState];
}